import adsAndServices from '@web-landing/public/categories/apps/adsAndServices.png';
import books from '@web-landing/public/categories/apps/books.png';
import business from '@web-landing/public/categories/apps/business.png';
import education from '@web-landing/public/categories/apps/education.png';
import entertainment from '@web-landing/public/categories/apps/entertainment.png';
import finance from '@web-landing/public/categories/apps/finance.png';
import foodAndDrink from '@web-landing/public/categories/apps/foodAndDrink.png';
import gambling from '@web-landing/public/categories/apps/gambling.png';
import health from '@web-landing/public/categories/apps/health.png';
import lifestyle from '@web-landing/public/categories/apps/lifestyle.png';
import news from '@web-landing/public/categories/apps/news.png';
import parenting from '@web-landing/public/categories/apps/parenting.png';
import pets from '@web-landing/public/categories/apps/pets.png';
import purchases from '@web-landing/public/categories/apps/purchases.png';
import social from '@web-landing/public/categories/apps/social.png';
import sport from '@web-landing/public/categories/apps/sport.png';
import state from '@web-landing/public/categories/apps/state.png';
import tools from '@web-landing/public/categories/apps/tools.png';
import transport from '@web-landing/public/categories/apps/transport.png';
import travelling from '@web-landing/public/categories/apps/travelling.png';
import action from '@web-landing/public/categories/games/action.png';
import adventure from '@web-landing/public/categories/games/adventure.png';
import ar from '@web-landing/public/categories/games/ar.png';
import arcade from '@web-landing/public/categories/games/arcade.png';
import board from '@web-landing/public/categories/games/board.png';
import boardAndCard from '@web-landing/public/categories/games/boardAndCard.png';
import card from '@web-landing/public/categories/games/card.png';
import casino from '@web-landing/public/categories/games/casino.png';
import casual from '@web-landing/public/categories/games/casual.png';
import children from '@web-landing/public/categories/games/children.png';
import family from '@web-landing/public/categories/games/family.png';
import indie from '@web-landing/public/categories/games/indie.png';
import music from '@web-landing/public/categories/games/music.png';
import paid from '@web-landing/public/categories/games/paid.png';
import puzzle from '@web-landing/public/categories/games/puzzle.png';
import quiz from '@web-landing/public/categories/games/quiz.png';
import race from '@web-landing/public/categories/games/race.png';
import rolePlaying from '@web-landing/public/categories/games/rolePlaying.png';
import shooter from '@web-landing/public/categories/games/shooter.png';
import simulator from '@web-landing/public/categories/games/simulator.png';
import sports from '@web-landing/public/categories/games/sports.png';
import strategy from '@web-landing/public/categories/games/strategy.png';
import utilities from '@web-landing/public/categories/games/utilities.png';
import word from '@web-landing/public/categories/games/word.png';

export const imagesMap = {
  games: {
    casual: casual.src,
    puzzle: puzzle.src,
    sports: sports.src,
    simulator: simulator.src,
    shooter: shooter.src,
    rolePlaying: rolePlaying.src,
    action: action.src,
    arcade: arcade.src,
    adventure: adventure.src,
    boardAndCard: boardAndCard.src,
    children: children.src,
    race: race.src,
    word: word.src,
    quiz: quiz.src,
    utilities: utilities.src,
    paid: paid.src,
    casino: casino.src,
    music: music.src,
    ar: ar.src,
    indie: indie.src,
    board: board.src,
    card: card.src,
    strategy: strategy.src,
    family: family.src,
  },
  apps: {
    entertainment: entertainment.src,
    foodAndDrink: foodAndDrink.src,
    parenting: parenting.src,
    lifestyle: lifestyle.src,
    education: education.src,
    social: social.src,
    news: news.src,
    adsAndServices: adsAndServices.src,
    pets: pets.src,
    health: health.src,
    purchases: purchases.src,
    tools: tools.src,
    travelling: travelling.src,
    books: books.src,
    sport: sport.src,
    transport: transport.src,
    gambling: gambling.src,
    finance: finance.src,
    state: state.src,
    business: business.src,
  },
} as Record<'apps' | 'games', Record<string, string>>;
